import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components";
import MuiTextField from '@material-ui/core/TextField';
import MuiInputAdornment from '@material-ui/core/InputAdornment';
import { Refresh as MuiRefresh } from "@material-ui/icons";
import styles from "../../styles";

const ClientTaskRow = styled.div`
  ${styles.ClientTaskRow}
  ${p => `& > span:first-child { margin-left: ${p.indent * 20}px; }`}
`;
const InputAdornment = styled(MuiInputAdornment)`
  ${styles.InputAdornment}
`;
const TextField = styled(MuiTextField)`
  ${styles.RateTextField}
  input { padding: ${p => p.ratePresent ? '5px 15px 5px 5px' : '5px 15px'} }
`;
const CheckboxWrapper = styled.div`
  ${styles.CheckboxWrapper}
`;
const Refresh = styled(MuiRefresh)`
  ${styles.Refresh}
  && { margin-right: ${p => p.isTask ? "65px" : "15px"};}

  @media (max-width: 600px) {
    &&&& { margin-right: ${p => p.isTask ? "38px" : "5px"}; }
  }
`;

class ClientTaskRate extends React.Component {
  state = {
    billable: this.props.billable,
    rate: this.props.rate ? parseFloat(this.props.rate).toFixed(2) : this.props.rate
  }

  handleCheckbox = () => {
    const { client, task, clientTaskUser, clientTaskType, handleClientTaskRate } = this.props;
    const billable = !this.state.billable;
    this.setState({ billable })
    handleClientTaskRate(client.id, task.id, clientTaskUser.rate, billable, true)
    if (billable) {
      setTimeout(() => {
        document.getElementById(`${client.id}_${task.id}_${clientTaskType}`).focus()
      }, 0);
    }
  }

  handleRateChange = (event) => this.setState({rate: event.target.value})

  handleResetClick = () => {
    const { client, task, clientTaskUser, handleClientTaskRate } = this.props;
    const { billable } = this.state;

    const confirm = window.confirm("Are you sure you want to reset the rate so it inherits from it's parent?");
    if (confirm) handleClientTaskRate(client.id, task.id, clientTaskUser.rate, billable, false)
  }

  render () {
    const { handleCheckbox, handleRateChange, handleResetClick } = this;
    const { billable, rate } = this.state;
    const {
      clientTaskUser,
      client,
      task,
      clientTaskType,
      handleClientTaskRate,
    } = this.props;

    const isTask = clientTaskType === 'client';
    const ratePresent = (billable && rate !== null && rate !== "");

    const adornment = <InputAdornment position="start">$</InputAdornment>

    return (
      <ClientTaskRow indent={client.indent}>
        <span>{ this.props[clientTaskType].name}</span>
        <span />
        {
          clientTaskUser.rate_changed ?
            <Refresh {...{isTask}} onClick={handleResetClick} /> :
            <span />
        }
        <CheckboxWrapper>
          <div className="hl_checkbox">
            <input
              className="display_none"
              type="checkbox"
              name={`${client.id}_${task.id}`}
              id={`${client.id}_${task.id}`}
              checked={billable}
              onChange={() => {}}
            />
            <label onClick={handleCheckbox} htmlFor={`${client.id}_${task.id}`}></label>
          </div>
        </CheckboxWrapper>
        <TextField
          id={`${client.id}_${task.id}_${clientTaskType}`}
          value={ ratePresent ? rate : ""}
          placeholder={rate ? parseFloat(rate).toFixed(2) : ""}
          onChange={handleRateChange}
          onBlur={event => handleClientTaskRate(client.id, task.id, event.target.value, billable, true)}
          margin="normal"
          variant="filled"
          disabled={!billable}
          InputProps={{
            startAdornment: ratePresent ? adornment : null,
            disableUnderline: true
          }}
          ratePresent={ratePresent}
        />
      </ClientTaskRow>
    );
  }
}


ClientTaskRate.propTypes = {
  clientTaskUser: PropTypes.object,
  client: PropTypes.object,
  task: PropTypes.object,
  handleClientTaskRate: PropTypes.func,
  clientTaskType: PropTypes.string
};
export default ClientTaskRate
